import React from 'react';
import { motion } from 'framer-motion';
import { FolderKanban, BarChart3, Users } from 'lucide-react';

const BusinessesSection: React.FC = () => {
  const features = [
    {
      icon: FolderKanban,
      title: 'All-in-One Management',
      description: 'Centralize customers, measurements, patterns, and orders in one secure CRM.',
    },
    {
      icon: BarChart3,
      title: 'Data-Driven Insights',
      description: 'Get reports to understand performance, streamline production times, and make smarter business decisions.',
    },
    {
      icon: Users,
      title: 'Customer Loyalty',
      description: 'Automate communication and transparency, building lasting relationships and repeat business.',
    },
  ];

  return (
    <section className="bg-brand-yellow py-16 lg:py-20 relative overflow-hidden">
      {/* Decorative Blue Circles */}
      <div className="absolute left-[-53px] top-[-38px] w-[247px] h-[309px] hidden lg:block">
        <div className="w-full h-full bg-brand-blue rounded-full opacity-30" style={{ borderRadius: '50%' }}></div>
      </div>
      <div className="absolute right-[-53px] bottom-[-38px] w-[249px] h-[178px] hidden lg:block">
        <div className="w-full h-full bg-brand-blue rounded-full opacity-30" style={{ borderRadius: '50%' }}></div>
      </div>

      <div className="max-w-container-lg mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="font-manrope text-body-small text-brand-blue mb-4"
          >
            Focus on tools, efficiency, and growth.
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="font-opensans text-display-xl text-brand-blue font-bold mb-6"
          >
            Businesses
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="font-manrope text-body-medium text-brand-blue max-w-[547px] mx-auto"
          >
            Whether you are a tailor or a designer, Master Ji gives you powerful, simple tools to focus on exceptional clothing while we handle the management.
          </motion.p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <motion.div
                key={feature.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="text-center"
              >
                {/* Icon Circle */}
                <div className="bg-brand-cream w-[172px] h-[172px] rounded-[86px] mx-auto mb-6 flex items-center justify-center">
                  <Icon className="w-16 h-16 text-brand-blue" />
                </div>

                {/* Feature Title */}
                <h3 className="font-opensans text-heading-2 text-brand-blue font-bold mb-4">
                  {feature.title}
                </h3>

                {/* Description */}
                <p className="font-manrope text-body-medium text-brand-blue max-w-[304px] mx-auto">
                  {feature.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BusinessesSection;

